/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Cloud Drive
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {BanUsersBody} from './schemas/ban-users-body';

import type {CreateUserBody} from './schemas/create-user-body';

import type {CreateUser200} from './schemas/create-user200';

import type {DeleteUsersParams} from './schemas/delete-users-params';

import type {ExportUsersCsv200} from './schemas/export-users-csv200';

import type {ImpersonateUser200} from './schemas/impersonate-user200';

import type {ListUsersParams} from './schemas/list-users-params';

import type {ListUsers200} from './schemas/list-users200';

import type {RetrieveUserParams} from './schemas/retrieve-user-params';

import type {RetrieveUser200} from './schemas/retrieve-user200';

import type {UpdateUserBody} from './schemas/update-user-body';

import type {UpdateUser200} from './schemas/update-user200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all users
 */
export const listUsers = (
  params?: ListUsersParams,
  options?: SecondParameter<typeof orvalApiFetch<ListUsers200>>,
) => {
  return orvalApiFetch<ListUsers200>(
    {url: `/users`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Create a user
 */
export const createUser = (
  createUserBody: CreateUserBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateUser200>>,
) => {
  return orvalApiFetch<CreateUser200>(
    {
      url: `/users`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: createUserBody,
    },
    options,
  );
};
/**
 * @summary Retrieve a user
 */
export const retrieveUser = (
  id: number,
  params?: RetrieveUserParams,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveUser200>>,
) => {
  return orvalApiFetch<RetrieveUser200>(
    {url: `/users/${id}`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Update a user
 */
export const updateUser = (
  userId: number,
  updateUserBody?: UpdateUserBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateUser200>>,
) => {
  return orvalApiFetch<UpdateUser200>(
    {
      url: `/users/${userId}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: updateUserBody,
    },
    options,
  );
};
/**
 * @summary Bulk delete users
 */
export const deleteUsers = (
  params: DeleteUsersParams,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/users/bulk`, method: 'DELETE', params},
    options,
  );
};
/**
 * @summary Export users as CSV
 */
export const exportUsersCsv = (
  options?: SecondParameter<typeof orvalApiFetch<ExportUsersCsv200>>,
) => {
  return orvalApiFetch<ExportUsersCsv200>(
    {url: `/users/csv/export`, method: 'POST'},
    options,
  );
};
/**
 * @summary Ban users
 */
export const banUsers = (
  userIds: string,
  banUsersBody?: BanUsersBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/users/ban/${userIds}`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: banUsersBody,
    },
    options,
  );
};
/**
 * @summary Unban users
 */
export const unbanUsers = (
  userIds: string,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/users/unban/${userIds}`, method: 'DELETE'},
    options,
  );
};
/**
 * @summary Impersonate a user
 */
export const impersonateUser = (
  userId: number,
  options?: SecondParameter<typeof orvalApiFetch<ImpersonateUser200>>,
) => {
  return orvalApiFetch<ImpersonateUser200>(
    {url: `/admin/users/impersonate/${userId}`, method: 'POST'},
    options,
  );
};
export type ListUsersResult = NonNullable<
  Awaited<ReturnType<typeof listUsers>>
>;
export type CreateUserResult = NonNullable<
  Awaited<ReturnType<typeof createUser>>
>;
export type RetrieveUserResult = NonNullable<
  Awaited<ReturnType<typeof retrieveUser>>
>;
export type UpdateUserResult = NonNullable<
  Awaited<ReturnType<typeof updateUser>>
>;
export type DeleteUsersResult = NonNullable<
  Awaited<ReturnType<typeof deleteUsers>>
>;
export type ExportUsersCsvResult = NonNullable<
  Awaited<ReturnType<typeof exportUsersCsv>>
>;
export type BanUsersResult = NonNullable<Awaited<ReturnType<typeof banUsers>>>;
export type UnbanUsersResult = NonNullable<
  Awaited<ReturnType<typeof unbanUsers>>
>;
export type ImpersonateUserResult = NonNullable<
  Awaited<ReturnType<typeof impersonateUser>>
>;
